import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'daysDifference',
    standalone: true
})
export class DaysDifferencePipe implements PipeTransform {
    private translate = inject(TranslateService);

    transform(value: Date | string | number, lang?: string): string {
        if (!value) return '';
        const now = new Date();
        const date = new Date(value);
        const diffMs = date.getTime() - now.getTime();
        const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
        const currentLang = lang || this.translate.currentLang || this.translate.defaultLang || 'nl';

        // Translation keys
        const keys = {
            today: 'daysDifference.today',
            oneDay: 'daysDifference.oneDay',
            days: 'daysDifference.days',
            oneDayAgo: 'daysDifference.oneDayAgo',
            daysAgo: 'daysDifference.daysAgo',
        };

        if (diffDays === 0) return this.translate.instant(keys.today, {});
        if (diffDays === 1) return this.translate.instant(keys.oneDay, {});
        if (diffDays > 1)  return this.translate.instant(keys.days, { count: Math.abs(diffDays) });
        if (diffDays === -1) return this.translate.instant(keys.oneDayAgo, {});
        return this.translate.instant(keys.daysAgo, { count: Math.abs(diffDays) });
    }
}
